import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function StorySection() {
  return <section className="py-16 md:py-24 px-4 bg-sage/50" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="relative bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-primary/10" data-id="element-229">
          <Quote className="absolute top-6 left-6 md:top-10 md:left-10 w-12 h-12 text-accent/30 transform -scale-x-100" data-id="element-230" />

          <div className="relative z-10 pl-4 md:pl-8 border-l-4 border-accent" data-id="element-231">
            <p className="text-lg md:text-2xl text-ink leading-relaxed italic font-medium" data-id="element-232">
              "Es lunes por la mañana. Escuchas la alarma, pero sientes que el
              cuerpo te pesa 20 kilos más de lo que marca la báscula. Vas al
              armario, eliges ese pantalón que tanto te gusta y, al intentar
              subir el cierre, la realidad te golpea: no cierra.
              <br data-id="element-233" />
              <br data-id="element-234" />
              No es solo grasa. Es esa pesadez abdominal, los dedos hinchados y
              una neblina mental que te persigue desde que te despiertas hasta
              que te acuestas. Sientes que tu cuerpo está en guerra contigo, y
              el café ya no es suficiente para mantenerte en pie."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}